// extracted by mini-css-extract-plugin
export default {"main":"Radio_main__pd1a6"};